/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The ManagerAccountControllerDtoLoginResponse model module.
 * @module model/ManagerAccountControllerDtoLoginResponse
 * @version 1.0
 */
class ManagerAccountControllerDtoLoginResponse {
    /**
     * Constructs a new <code>ManagerAccountControllerDtoLoginResponse</code>.
     * @alias module:model/ManagerAccountControllerDtoLoginResponse
     */
    constructor() { 
        
        ManagerAccountControllerDtoLoginResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ManagerAccountControllerDtoLoginResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerAccountControllerDtoLoginResponse} obj Optional instance to populate.
     * @return {module:model/ManagerAccountControllerDtoLoginResponse} The populated <code>ManagerAccountControllerDtoLoginResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerAccountControllerDtoLoginResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('twofaAuthCode')) {
                obj['twofaAuthCode'] = ApiClient.convertToType(data['twofaAuthCode'], 'String');
            }
            if (data.hasOwnProperty('twofaImage')) {
                obj['twofaImage'] = ApiClient.convertToType(data['twofaImage'], 'String');
            }
            if (data.hasOwnProperty('twofaManualSetupCode')) {
                obj['twofaManualSetupCode'] = ApiClient.convertToType(data['twofaManualSetupCode'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerAccountControllerDtoLoginResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerAccountControllerDtoLoginResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['twofaAuthCode'] && !(typeof data['twofaAuthCode'] === 'string' || data['twofaAuthCode'] instanceof String)) {
            throw new Error("Expected the field `twofaAuthCode` to be a primitive type in the JSON string but got " + data['twofaAuthCode']);
        }
        // ensure the json data is a string
        if (data['twofaImage'] && !(typeof data['twofaImage'] === 'string' || data['twofaImage'] instanceof String)) {
            throw new Error("Expected the field `twofaImage` to be a primitive type in the JSON string but got " + data['twofaImage']);
        }
        // ensure the json data is a string
        if (data['twofaManualSetupCode'] && !(typeof data['twofaManualSetupCode'] === 'string' || data['twofaManualSetupCode'] instanceof String)) {
            throw new Error("Expected the field `twofaManualSetupCode` to be a primitive type in the JSON string but got " + data['twofaManualSetupCode']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
ManagerAccountControllerDtoLoginResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
ManagerAccountControllerDtoLoginResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
ManagerAccountControllerDtoLoginResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
ManagerAccountControllerDtoLoginResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
ManagerAccountControllerDtoLoginResponse.prototype['contentsReward'] = undefined;

/**
 * @member {String} twofaAuthCode
 */
ManagerAccountControllerDtoLoginResponse.prototype['twofaAuthCode'] = undefined;

/**
 * @member {String} twofaImage
 */
ManagerAccountControllerDtoLoginResponse.prototype['twofaImage'] = undefined;

/**
 * @member {String} twofaManualSetupCode
 */
ManagerAccountControllerDtoLoginResponse.prototype['twofaManualSetupCode'] = undefined;






export default ManagerAccountControllerDtoLoginResponse;

